import { render, staticRenderFns } from "./SupplierField.vue?vue&type=template&id=bd1de8ac"
import script from "./SupplierField.vue?vue&type=script&lang=js"
export * from "./SupplierField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports